import React from 'react'
import { Container, Flex } from '@quark/layout'
import { Text } from '@quark/typography'
import { Layer } from '@quark/layer'
import { Button } from '@quark/button'
import { ChevronRight } from '@quark/icons'
import Image from 'next/image'

const TravelPass = () => (
  <div
    style={{ width: '500px', height: '332px', cursor: 'pointer' }}
    onClick={() => {
      window.open('/airpass', '_blank')
    }}>
    <Container borderRadius="radius-2xl" type="max-parent" overflow="hidden">
      <Layer gradient="linear-gradient(180deg, rgba(0, 0, 0, 0.80) 0%, rgba(0, 0, 0, 0.48) 100%)">
        <Container paddingTop="spacing-44" paddingLeft="spacing-24" paddingRight="spacing-24" type="max-parent">
          <Flex flexDirection="column" alignItems="center" justifyContent="space-between" size="fullHeight">
            <Flex flexDirection="column" alignItems="center" gap="spacing-12">
              <Text textAlign="center" fontStyle="um_text-xl/bold" color="static/Primary-onDark">
                The only pass that pays you back for flight troubles{' '}
              </Text>
              <Button type="staticOnDarkSolid" size="lg">
                <Flex gap="spacing-2" alignItems="center">
                  <Text color="base/primary" fontStyle="um_text-base/normal">
                    Know more
                  </Text>
                  <Text color="base/primary" fontStyle="um_text-base/normal" lineHeight="line-height-0">
                    <ChevronRight />
                  </Text>
                </Flex>
              </Button>
            </Flex>
            <Image
              height={141}
              width={248}
              src="https://acko-cms-dev.s3.ap-south-1.amazonaws.com/image_689_bd66c5727a.webp"
              alt="airpass"
            />
          </Flex>
        </Container>
      </Layer>
    </Container>
  </div>
)

export default TravelPass
